import { createActionCreator } from '../../utils/helpers';

import {
  apiKey,
  profileId,
  questionnairePrefill,
  CLOSE_QUESTIONNAIRE,
  OPEN_QUESTIONNAIRE,
  questionnaireMatchesResults,
} from './types';

export const openQuestionnaire = createActionCreator(OPEN_QUESTIONNAIRE, 'options');
export const closeQuestionnaire = createActionCreator(CLOSE_QUESTIONNAIRE);
export const requestApiKey = createActionCreator(apiKey.request);
export const requestApiKeySuccess = createActionCreator(apiKey.success, 'response');
export const requestApiKeyFailure = createActionCreator(apiKey.failure, 'error');

export const requestQuestionnairePrefill = (payload, promise) => ({
  type: questionnairePrefill.request,
  payload,
  promise,
});

export const requestQuestionnairePrefillSuccess = (payload, promise) => ({
  type: questionnairePrefill.success,
  payload,
  promise,
});

export const requestQuestionnairePrefillFailure = (error) => ({
  type: questionnairePrefill.failure,
  error,
});

export const requestProfileId = (questionnaireId, promise) => ({
  type: profileId.request,
  questionnaireId,
  promise,
});

export const requestProfileIdSuccess = (response) => ({
  type: profileId.success,
  response,
});

export const requestProfileIdFailure = (error) => ({
  type: profileId.failure,
  error,
});

export const requestQuestionnaireMatchesResults = (payload, promise) => ({
  type: questionnaireMatchesResults.request,
  payload: payload,
  productId: payload.productId,
  promise,
});

export const requestMatchesResultsDataSuccess = (data, productId) => ({
  type: questionnaireMatchesResults.success,
  data,
  productId,
});

export const requestMatchesResultsDataFailure = (data, productId) => ({
  type: questionnaireMatchesResults.failure,
  data,
  productId,
});
